// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import Tdg_UserModel from '../../model/tdg-user-model';
import Tdg_UserDTO from '../dto/tdg-user-dto';
import dtoSchema from '../schemas/tdg-user-schema';
import ResourceLinkModel from '../../model/resource-link-model';

export default abstract class Tdg_UserModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<Tdg_UserDTO>) {
    super();
    if (data) {
      this.id = data.id;
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.creatorId = data.creatorId;
      this.creatorName = data.creatorName ?? undefined;
      this.created = data.created;
      this.modifierId = data.modifierId ?? undefined;
      this.modifierName = data.modifierName ?? undefined;
      this.modified = data.modified ?? undefined;
      this.userId = data.userId;
      this.registrationType = data.registrationType;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;
  /**
  */
  links?: ResourceLinkModel[];
  /**
  * @type {int64}
  */
  creatorId?: number;
  /**
  */
  creatorName?: string;
  /**
  * @type {date-time}
  */
  created?: string;
  /**
  * @type {int64}
  */
  modifierId?: number;
  /**
  */
  modifierName?: string;
  /**
  * @type {date-time}
  */
  modified?: string;
  /**
  * @type {int32}
  */
  userId?: number;
  /**
  * @minimum 1
  */
  registrationType?: string;

  static toModel(dto: DeepPartial<Tdg_UserDTO>): Tdg_UserModel;
  static toModel(dto: DeepPartial<Tdg_UserDTO> | undefined | null): Tdg_UserModel | undefined;
  static toModel(dto: DeepPartial<Tdg_UserDTO> | undefined | null): Tdg_UserModel | undefined {
    return dto ? new Tdg_UserModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<Tdg_UserModel> | Tdg_UserModel): Tdg_UserDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
      links: unwrapped.links,
      creatorId: unwrapped.creatorId,
      creatorName: unwrapped.creatorName,
      created: unwrapped.created,
      modifierId: unwrapped.modifierId,
      modifierName: unwrapped.modifierName,
      modified: unwrapped.modified,
      userId: unwrapped.userId,
      registrationType: unwrapped.registrationType,
    } as Tdg_UserDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for Tdg_UserModel, can not map to Tdg_UserDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
